import * as React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {HandlerShowMessage, handleScrollIntoView, removeNonNumeric} from "../assets/js/main";
import {Box, CircularProgress} from "@mui/material";
import NavBar from "../components/NavBar";
import {setLoading} from "../redux/loading/actions";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useSnackbar} from "notistack";
import HandleFetchData from "../plugin/HandleFetchData";


export default function OrderCancellation(props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [searchParams] = useSearchParams();
  const {enqueueSnackbar} = useSnackbar();
  const location = useLocation();

  const {fetchData} = HandleFetchData()
  const {showMessage} = HandlerShowMessage();

  const fullNameRef = React.useRef()
  const phoneRef = React.useRef()
  const orderNoRef = React.useRef()
  const cancellationRef = React.useRef()
  const descRef = React.useRef()
  const depositMethodRef = React.useRef()
  const percentRef = React.useRef()

  const [fullName, setFullName] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [orderNo, setOrderNo] = React.useState(searchParams.get('orderId'));
  const [cancellation, setCancellation] = React.useState('');
  const [desc, setDesc] = React.useState('');
  const [percent, setPercent] = React.useState('');
  const [depositMethod, setDepositMethod] = React.useState('');
  const [postService, setPostService] = React.useState(false);
  const [supportService, setSupportService] = React.useState(false);
  const [carton, setCarton] = React.useState(false);
  const [collect, setCollect] = React.useState(false);
  const [validations, setValidations] = React.useState({});

  // console.log('location', location)

  React.useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('info-user'))

    setFullName(userInfo?.FullName)
    setPhone(userInfo?.Mobile)
  }, [])

  const validationInput = (event) => {
    event.preventDefault();

    if (!fullName) {
      handleScrollIntoView(fullNameRef)
      setValidations({
        fullName: 'وارد کردن نام و نام خانوادگی الزامی میباشد'
      })
    } else if (!phone) {
      handleScrollIntoView(phoneRef)
      setValidations({
        phone: 'وارد کردن تلفن همراه الزامی میباشد'
      })
    } else if (!orderNo) {
      handleScrollIntoView(orderNoRef)
      setValidations({
        orderNo: 'وارد کردن شماره سفارش الزامی میباشد'
      })
    } else if (!desc) {
      handleScrollIntoView(descRef)
      setValidations({
        desc: 'وارد کردن توضیحات الزامی میباشد'
      })
    } else {
      handleSubmit()
    }
  }


  const handleSubmit = async () => {
    setValidations({})
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'POST', '/v1/OrderCancellation', {
         "ticketId": 0,
         "fullName": fullName,
         "mobileNumber": phone,
         "orderNo": orderNo,
         "cancellationReason": Number(cancellation),
         "description": desc,
         "returnPostServicePrice": postService,
         "returnSupportServicePrice": supportService,
         "returnBoxingServicePrice": carton,
         "returnPickupingServicePrice": collect,
         "returnPricePercent": Number(percent?.split(',').join('')),
         "paymentType": Number(depositMethod)
       },
       "application/json", '', 'postex'
    )


    showMessage(fetch?.status)
    fetch?.success && navigate(-1)

    // setResApi(fetch)
    dispatch(setLoading(false))
  }


  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="orderCancellationPage">
           <div className="titlePage">
             <h1>{t("orderCancellation.t1")}</h1>
           </div>
           <div className="form">
             <form onSubmit={validationInput}>
               <div className="row">
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("orderCancellation.t3")}</label>
                     <input type="text" name="fullName" id="fullName"
                            value={fullName} ref={fullNameRef}
                            onChange={e => setFullName(e.target.value)}/>
                     {
                       validations?.fullName &&
                       <p className="error">{validations?.fullName}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("orderCancellation.t4")}</label>
                     <input type="text" name="phone" className="numeric" inputMode='numeric' id="phone"
                            value={phone} ref={phoneRef}
                            onChange={e => setPhone(removeNonNumeric(e.target.value))}/>
                     {
                       validations?.phone &&
                       <p className="error">{validations?.phone}</p>
                     }
                   </div>
                 </div>
                 <div className="col-12 col-md-6">
                   <div className="input">
                     <label>{t("orderCancellation.t5")}</label>
                     <input type="text" name="orderNo" id="orderNo"
                            value={orderNo} ref={orderNoRef}
                            onChange={e => setOrderNo(removeNonNumeric(e.target.value))}/>
                     {
                       validations?.orderNo &&
                       <p className="error">{validations?.orderNo}</p>
                     }
                   </div>
                 </div>
                 {/*<div className="col-12 col-md-6">*/}
                 {/*  <div className="input">*/}
                 {/*    <label>{t("orderCancellation.t6")}</label>*/}
                 {/*    <select aria-label="Default select example" value={cancellation} id="cancellation" ref={cancellationRef}*/}
                 {/*            onChange={e => setCancellation(e.target.value)}>*/}
                 {/*      <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>*/}
                 {/*      <option value="0">{t("orderCancellation.t7")}</option>*/}
                 {/*      <option value="1">{t("orderCancellation.t8")}</option>*/}
                 {/*      <option value="2">{t("orderCancellation.t9")}</option>*/}
                 {/*      <option value="3">{t("orderCancellation.t10")}</option>*/}
                 {/*      <option value="4">{t("orderCancellation.t11")}</option>*/}
                 {/*      <option value="5">{t("orderCancellation.t12")}</option>*/}
                 {/*      <option value="6">{t("orderCancellation.t13")}</option>*/}
                 {/*      <option value="7">{t("orderCancellation.t14")}</option>*/}
                 {/*      <option value="8">{t("orderCancellation.t15")}</option>*/}
                 {/*      <option value="9">{t("orderCancellation.t16")}</option>*/}
                 {/*    </select>*/}

                 {/*    {*/}
                 {/*      validations?.cancellation &&*/}
                 {/*      <p className="error">{validations?.cancellation}</p>*/}
                 {/*    }*/}
                 {/*  </div>*/}
                 {/*</div>*/}
                 <div className="col-12">
                   <div className="input">
                     <label>{t("orderCancellation.t17")}</label>
                     <textarea rows="5" value={desc} onChange={e => setDesc(e.target.value)} id="desc" ref={descRef}/>
                     {
                       validations?.desc &&
                       <p className="error">{validations?.desc}</p>
                     }
                   </div>
                 </div>
                 {/*<div className="col-12 col-md-6">*/}
                 {/*  <div className="input">*/}
                 {/*    <label>{t("orderCancellation.t23")}</label>*/}
                 {/*    <select aria-label="Default select example" value={depositMethod} id="depositMethod" ref={depositMethodRef}*/}
                 {/*            onChange={e => setDepositMethod(e.target.value)}>*/}
                 {/*      <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>*/}
                 {/*      <option value="0">{t("orderCancellation.t24")}</option>*/}
                 {/*      <option value="1">{t("orderCancellation.t25")}</option>*/}
                 {/*    </select>*/}
                 {/*    {*/}
                 {/*      validations?.depositMethod &&*/}
                 {/*      <p className="error">{validations?.depositMethod}</p>*/}
                 {/*    }*/}
                 {/*  </div>*/}
                 {/*</div>*/}
                 <div className="col-12">
                   <div className="btnGroup_yellow mb-0 mt-4">
                     <button type="submit" className="btnFill justify-content-center m-0" disabled={selector?.loading?.isLoading}>
                       {
                         selector?.loading?.isLoading ?
                            <Box sx={{display: 'flex'}}>
                              <CircularProgress size={20}/>
                            </Box>
                            :
                            <span>{t("orderCancellation.t26")}</span>
                       }
                     </button>
                   </div>
                 </div>
               </div>
             </form>


             {/*<FormGroup>*/}
             {/*  <FormControlLabel control={<Checkbox checked={postService} id="postService"*/}
             {/*                                       onChange={e => setPostService(e.target.checked)}/>}*/}
             {/*                    label={t("orderCancellation.t18")}/>*/}
             {/*  <FormControlLabel control={<Checkbox checked={supportService} id="supportService"*/}
             {/*                                       onChange={e => setSupportService(e.target.checked)}/>}*/}
             {/*                    label={t("orderCancellation.t19")}/>*/}
             {/*  <FormControlLabel control={<Checkbox checked={carton} id="carton"*/}
             {/*                                       onChange={e => setCarton(e.target.checked)}/>}*/}
             {/*                    label={t("orderCancellation.t20")}/>*/}
             {/*  <FormControlLabel control={<Checkbox checked={collect} id="collect"*/}
             {/*                                       onChange={e => setCollect(e.target.checked)}/>}*/}
             {/*                    label={t("orderCancellation.t21")}/>*/}
             {/*</FormGroup>*/}


             {/*<div className="input">*/}
             {/*  <label>{t("orderCancellation.t22")}</label>*/}
             {/*  <input type="text" name="percent" id="percent"*/}
             {/*         value={percent} ref={percentRef}*/}
             {/*         onChange={e => setPercent(removeNonNumeric(e.target.value))}/>*/}
             {/*  {*/}
             {/*    validations?.percent &&*/}
             {/*    <p className="error">{validations?.percent}</p>*/}
             {/*  }*/}
             {/*</div>*/}


           </div>


         </div>
       </div>
     </>
  )
}
